export const getTextNode = () => ({
  group: 'inline'
});